const STORAGE_KEY = "onboarding";

interface OnboardingData {
  firstName?: string;
  lastName?: string;
  gender?: string;
  birthday?: string;
  woneDays?: string;
  woneDayTimings?: string;
  stressFrequency?: string;
  calendarPermission?: boolean | null;
  [key: string]: unknown;
}

export function getOnboardingData(): OnboardingData | null {
  const raw = localStorage.getItem(STORAGE_KEY);
  return raw ? JSON.parse(raw) : null;
}

export function setOnboardingData(updates: Partial<OnboardingData>) {
  const current = getOnboardingData() ?? {};
  localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...current, ...updates }));
}

export function clearOnboardingData() {
  localStorage.removeItem(STORAGE_KEY);
}
